// src/prints/InwardPrintPage.jsx
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import React, { useEffect, useState } from "react";
import axios from "axios";
import Logo from "../assets/infraLogo.jpg";

const API_BASE =
  import.meta.env?.VITE_API_BASE ||
  process.env.REACT_APP_API_BASE ||
  "https://rfs2.infraconsoft.net.in/api";

const API_ORIGIN = API_BASE.replace(/\/api\/?$/, "");

const InwardPrintPage = () => {
  useAuthRedirect();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  // ---- Site / Company info for header ----
  const [site, setSite] = useState({
    ok: true,
    name: "Infraconsoft",
    logo: null,
    address: "",
    email: "",
    phone: "",
    _ts: 0,
  });

  // Fetch site/company info
  useEffect(() => {
    let ignore = false;
    (async () => {
      try {
        const res = await axios.get(`${API_BASE}/siteinfo`);
        const s = res?.data || {};
        // ensure absolute logo URL if server ever returns relative
        let logo = s.logo || null;
        if (logo && !/^https?:\/\//i.test(logo)) {
          if (!logo.startsWith("/")) logo = `/${logo}`;
          logo = `${API_ORIGIN}${logo}`;
        }
        if (!ignore) {
          setSite({
            ok: !!s.ok,
            name: s.name || "Infraconsoft",
            logo,
            address: s.address || "",
            email: s.email || "",
            phone: s.phone || "",
            _ts: Date.now(),
          });
        }
      } catch (e) {
        // keep defaults on failure
        console.error("Failed to load /siteinfo", e);
      }
    })();
    return () => {
      ignore = true;
    };
  }, []);

  // Fetch list data
  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${API_BASE}/purchaseReq_diApprovePrint`);
      setData(response?.data?.prDisApproval || []);
    } catch (error) {
      console.error("Error fetching prDisApproval:", error);
    } finally {
      setLoading(false);
    }
  };

  const logoSrc = site.logo ? `${site.logo}${site._ts ? `?v=${site._ts}` : ""}` : Logo;

  return (
    <div className="inward-container">
      <header className="inward-header">
        <img src={logoSrc} alt={`${site.name} Logo`} className="inward-logo" />
        <div className="inward-title">
          <h2 style={{ textTransform: "uppercase" }}>{site.name || "Infraconsoft"}</h2>
          {site.address && <p>Regd office: {site.address}</p>}
          {(site.phone || site.email) && (
            <p>
              {site.phone && <span>Ph: {site.phone}</span>}
              {site.phone && site.email && <span> | </span>}
              {site.email && <span>E-mail: {site.email}</span>}
            </p>
          )}
        </div>
        <div className="inward-po">PR Disapproval List</div>
      </header>

      <table className="inward-table">
        <thead>
          <tr>
            <th>PR No</th>
            <th>Branch</th>
            <th>Date</th>
            <th>Department</th>
            <th>H.O.D</th>
            <th>Indent Ref.</th>
            <th>Head Meterial</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr>
              {/* 7 columns total */}
              <td colSpan="7" className="inward-loading-text">
                Loading data, please wait...
              </td>
            </tr>
          ) : data.length > 0 ? (
            // Group by header number (pnumber)
            Object.values(
              data.reduce((acc, item) => {
                const headerNo = item.pnumber;
                if (!acc[headerNo]) acc[headerNo] = { header: item, details: [] };
                acc[headerNo].details.push(item);
                return acc;
              }, {})
            ).map((group, i) => (
              <React.Fragment key={i}>
                {/* Group Header Row */}
                <tr className="inward-header-row">
                  <td colSpan="7" className="inward-header-title">
                    STN No : {group.header.pnumber}
                  </td>
                </tr>

                {/* Detail Rows */}
                {group.details.map((item, index) => (
                  <tr key={index} className="inward-detail-row">
                    <td>{item.pnumber}</td>
                    <td>{item.fld_branchcode}</td>
                    <td>
                      {item.fld_duedate
                        ? new Date(item.fld_duedate).toLocaleDateString("en-GB")
                        : ""}
                    </td>
                    <td>{item.fld_dept}</td>
                    <td>{item.fld_hod}</td>
                    <td>{item.fld_inref}</td>
                    <td>{item.fld_headmet}</td>
                  </tr>
                ))}
              </React.Fragment>
            ))
          ) : (
            <tr>
              <td colSpan="7" style={{ textAlign: "center" }}>
                No Data Available
              </td>
            </tr>
          )}
        </tbody>
      </table>

      <div className="inward-print">
        <button onClick={() => window.print()}>🖨️ Print</button>
      </div>
    </div>
  );
};

export default InwardPrintPage;
